import { Box, CircularProgress } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import CardsContext from "../../services/cards/cards";
import UserContext from "../../services/user/user";
import ECard from "../_elements/ecard";
import EInfoToolTip from "../_elements/eInfo-tooltip";

import { FormattedMessage } from "react-intl";

export default function ValidTaxRateCard({
  dataPath,
  titleId,
  tooltipAbsoluteId1,
  tooltipAbsoluteId2,
  containerClass = "widget-col-6",
  testIdPrefix
}) {
  const [card, setCard] = useState({});
  const { currency, formatNumber } = useContext(UserContext);
  const { cardsData, getStatus, calcPercentage } = useContext(CardsContext);

  useEffect(() => {
    // setCard(cardsData.year);
    cardsData.year &&
      cardsData.year[dataPath] &&
      setCard(cardsData.year[dataPath]);
  }, [cardsData, dataPath]);

  const getCardStatus = (val) => {
    if (
      typeof card.current_year === "undefined" &&
      typeof card.previous_year === "undefined"
    ) {
      return "noData";
    } else {
      // if (card.current_year.percentage > 0) {
      //   return "success";
      // } else if (card.current_year.percentage === 0) {
      //   return "warning";
      // } else {
      //   return "error";
      // }
      return "default";
    }
  };

  const getChartObj = () => {
    if (
      typeof card.current_year === "undefined" &&
      typeof card.previous_year === "undefined"
    ) {
      return "";
    } else {
      // const num = formatNumber(
      //   (card.current_year.item_valid_tax_count /
      //     card.previous_year.item_valid_tax_count) *
      //     100,
      //   2
      // );

      return card.current_year.percentage;
    }
  };

  return (
    <div className={containerClass}>
      {!card ? (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <ECard
          variant="validTaxRate"
          title={<FormattedMessage id={titleId} />}
          value={
            Object.keys(card).length > 0 ? (
              formatNumber(card.current_year.item_valid_tax_count, 0) +
              " of " +
              formatNumber(card.current_year.item_count, 0)
            ) : (
              <FormattedMessage id="noData" />
            )
          }
          percent={
            Object.keys(card).length > 1 &&
            Object.keys(card.previous_year).length > 1 &&
            (card.previous_year.item_valid_tax_count !== 0 ||
              card.previous_year.item_count !== 0)
              ? formatNumber(card.previous_year.item_valid_tax_count, 0) +
                " of " +
                formatNumber(card.previous_year.item_count, 0)
              : "-"
          }
          // status={Card ? getStatus(card.percentage) : 'error'}
          status={getCardStatus()}
          gaugeStyle="navy"
          chartObj={{
            value: getChartObj()
          }}
          action={
            <EInfoToolTip
              status={getCardStatus()}
              msg={
                <ul className="tooltip-list">
                  <li>
                    {/* <strong style={{ color: eColors[0] }}>
                      <FormattedMessage id="absoluteNumber" />:
                    </strong>{" "} */}
                    <FormattedMessage
                      id={tooltipAbsoluteId1}
                      values={{
                        b: (...chunks) => {
                          return <b style={{ fontWeight: "800" }}>{chunks}</b>;
                        },
                        br: <br />
                      }}
                    />
                  </li>
                  <li>
                    <FormattedMessage
                      id={tooltipAbsoluteId2}
                      values={{
                        b: (...chunks) => {
                          return (
                            <b
                              style={{
                                fontWeight: "800",
                                color:
                                  card?.current_year?.percentage === 100
                                    ? "var(--font-strong-success)"
                                    : card?.current_year?.percentage > 49
                                    ? "var(--font-strong-warning)"
                                    : "var(--font-heavy-error)"
                              }}
                            >
                              {chunks}
                            </b>
                          );
                        },
                        br: <br />
                      }}
                    />
                  </li>
                </ul>
              }
              data-testid={testIdPrefix ? `${testIdPrefix}_tooltip` : undefined}
              tooltipContentTestId={
                testIdPrefix ? `${testIdPrefix}_tooltip_content` : undefined
              }
            />
          }
          data-testid={testIdPrefix ? `${testIdPrefix}_box` : undefined}
          cardHeaderTestId={
            testIdPrefix ? `${testIdPrefix}_heading` : undefined
          }
          cardValueTestId={testIdPrefix ? `${testIdPrefix}_data1` : undefined}
          cardPercentTestId={testIdPrefix ? `${testIdPrefix}_data2` : undefined}
          cardChartTestId={testIdPrefix ? `${testIdPrefix}_chart` : undefined}
        />
      )}
    </div>
  );
}
